import {Content} from './Content';
import {Header} from './Header';
import {Root} from './Root';
import {SubHeader} from './SubHeader';

export const FormBox = {
  Root,
  Header,
  SubHeader,
  Content,
};

export {Content as FormBoxContent};
export type {FormBoxContentProps} from './Content';
export {Header as FormBoxHeader};
export type {FormBoxHeaderProps} from './Header';
export {Root as FormBoxRoot};
export type {FormBoxRootProps} from './Root';
export {SubHeader as FormBoxSubHeader};
export type {FormBoxSubHeaderProps} from './SubHeader';
